import { render, staticRenderFns } from "./TextBtn.vue?vue&type=template&id=f1350b2a&scoped=true&lang=html&"
import script from "./TextBtn.vue?vue&type=script&lang=js&"
export * from "./TextBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1350b2a",
  null
  
)

export default component.exports